<template>
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="card mb-3">
        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="add">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <label class="form-label">Parent Scene</label>
                <select
                  class="form-select"
                  v-model.number="nitem.parentSceneId"
                  name="specialityDropdown5"
                >
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <span class="inputError">{{
                  errors.first("specialityDropdown5")
                }}</span>
              </div>
              <div class="col-md-6">
                <label class="form-label">Parent Choices</label>
                <select
                  class="form-select"
                  v-model.number="nitem.parentChoiceId"
                >
                  <option
                    v-for="choice in filteredChoices"
                    :key="choice.id"
                    :value="choice.id"
                  >
                    {{ choice.textEn }}
                  </option>
                </select>
              </div>

              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">Name</label>
                <input
                  type="text"
                  v-model="nitem.name"
                  name="name"
                  id="firstName"
                  class="form-control"
                  v-validate="{ required: true }"
                />
                <span class="inputError">{{ errors.first("name") }}</span>
              </div>
              <div class="col-md-6">
                <label class="form-label">Scenario</label>
                <select
                  class="form-select"
                  v-model.number="nitem.scenarioId"
                  name="specialityDropdown"
                  required
                >
                  <option
                    v-for="(item, index) in scenarios"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <span class="inputError">{{
                  errors.first("specialityDropdown")
                }}</span>
              </div>
              <div class="col-md-12">
                <label for="DescriptionAz" class="form-label"
                  >DescriptionAz
                </label>
                <textarea
                  rows="3"
                  v-model="nitem.descriptionAz"
                  name="DescriptionAz"
                  id="DescriptionAz"
                  class="form-control"
                  v-validate="{ required: true }"
                ></textarea>
                <span class="inputError">{{
                  errors.first("DescriptionAz")
                }}</span>
              </div>

              <div class="col-md-12">
                <label for="DescriptionEn" class="form-label"
                  >DescriptionEn</label
                >
                <textarea
                  rows="3"
                  v-model="nitem.descriptionEn"
                  name="DescriptionEn"
                  id="DescriptionEn"
                  class="form-control"
                  v-validate="{ required: true }"
                ></textarea>
                <span class="inputError">{{
                  errors.first("DescriptionEn")
                }}</span>
              </div>
              <div class="col-md-6">
                <label for="LocationAz" class="form-label">LocationAz</label>
                <input
                  type="text"
                  v-model="nitem.locationAz"
                  name="LocationAz"
                  id="LocationAz"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("LocationAz") }}</span>
              </div>

              <div class="col-md-6">
                <label for="LocationEn" class="form-label">LocationEn</label>
                <input
                  type="text"
                  v-model="nitem.locationEn"
                  name="LocationEn"
                  id="LocationEn"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("LocationEn") }}</span>
              </div>

              <div class="col-md-6">
                <label class="form-label">Character</label>
                <select
                  class="form-select"
                  v-model.number="nitem.characterId"
                  name="specialityDropdown2"
                >
                  <option :value="null"></option>
                  <option
                    v-for="(item, index) in characters"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.nameEn }}
                  </option>
                </select>
                <span class="inputError">{{
                  errors.first("specialityDropdown2")
                }}</span>
              </div>
              <div class="col-md-6">
                <label class="form-label">isQuestion</label>
                <select
                  class="form-select"
                  v-model.number="nitem.isQuestion"
                  name="specialityDropdown3"
                >
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
                <span class="inputError">{{
                  errors.first("specialityDropdown3")
                }}</span>
              </div>
              <div class="col-md-6" v-if="!nitem.isQuestion">
                <label class="form-label">Next Choice</label>
                <select class="form-select" v-model.number="nitem.nextSceneId">
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="Image" class="form-label">Image</label>
                <input
                  type="file"
                  @change="handleFileChange"
                  name="Image"
                  id="Image"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("Image") }}</span>
              </div>
              <div v-if="nitem.isQuestion">
                <hr />
                <br />

                <h3>Answer 1</h3>
                <br />
                <div class="col-md-12">
                  <label for="textAz" class="form-label">TextAz</label>
                  <input
                    type="text"
                    v-model="nitem.choices[0].textAz"
                    name="textAz"
                    id="textAz"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textAz") }}</span>
                </div>
                <div class="col-md-12">
                  <label for="textEn" class="form-label">TextEn</label>
                  <input
                    type="text"
                    v-model="nitem.choices[0].textEn"
                    name="textEn"
                    id="textEn"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textEn") }}</span>
                </div>
                <div class="col-md-6">
                  <label class="form-label">ChoiceValues</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[0].choiceValueId"
                    name="specialityDropdown4"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(item, index) in choiceValues"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="inputError">{{
                    errors.first("specialityDropdown4")
                  }}</span>
                </div>
                <div class="col-md-12 mt-2">
                  <label class="form-label">Next Scene</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[0].nextSceneId"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="scene in scenesWithChoices"
                      :key="scene.id"
                      :value="scene.id"
                    >
                      {{ scene.name }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label class="form-label">Is Correct?</label>
                  <select
                    class="form-select"
                    v-model="nitem.choices[0].isCorrect"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <hr />
                <br />

                <h3>Answer 2</h3>
                <br />
                <div class="col-md-12">
                  <label for="textAz" class="form-label">TextAz</label>
                  <input
                    type="text"
                    v-model="nitem.choices[1].textAz"
                    name="textAz"
                    id="textAz"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textAz") }}</span>
                </div>
                <div class="col-md-12">
                  <label for="textEn" class="form-label">TextEn</label>
                  <input
                    type="text"
                    v-model="nitem.choices[1].textEn"
                    name="textEn"
                    id="textEn"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textEn") }}</span>
                </div>
                <div class="col-md-6">
                  <label class="form-label">ChoiceValues</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[1].choiceValueId"
                    name="specialityDropdown4"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(item, index) in choiceValues"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="inputError">{{
                    errors.first("specialityDropdown4")
                  }}</span>
                </div>
                <div class="col-md-12 mt-2">
                  <label class="form-label">Next Scene</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[1].nextSceneId"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="scene in scenesWithChoices"
                      :key="scene.id"
                      :value="scene.id"
                    >
                      {{ scene.name }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label class="form-label">Is Correct?</label>
                  <select
                    class="form-select"
                    v-model="nitem.choices[1].isCorrect"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <hr />
                <br />
              </div>
            </div>
            <!-- Submit button -->
            <button
              type="submit"
              class="btn btn-primary mt-4"
              :disabled="loading"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
    <div v-if="loading" class="global-loader">
      <div class="spinner-border text-light" role="status"></div>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from "../../../jwt.interceptor";

export default {
  name: "SceneCreate",
  data() {
    return {
      nitem: {
        name: "",
        descriptionAz: "",
        descriptionEn: "",
        locationAz: "",
        locationEn: "",
        isQuestion: false,
        scenarioId: "",
        characterId: "",
        image: null,

        parentSceneId: null,
        parentChoiceId: null,

        choices: [
          {
            textAz: "",
            textEn: "",
            choiceValueId: "",
            isCorrect: false,
            nextSceneId: null,
          },
          {
            textAz: "",
            textEn: "",
            choiceValueId: "",
            isCorrect: false,
            nextSceneId: null,
          },
        ],
      },

      scenarios: [],
      characters: [],
      choiceValues: [],
      scenesWithChoices: [],
      loading: false,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.nitem.image = file;
      }
    },
    async add() {
      const validForm = await this.isFormValid();
      if (!validForm) {
        this.$toast.error("Cells are not filled correctly!", {
          position: "top-right",
        });
        return;
      }

      if (this.nitem.choices[1].textAz === "" && this.nitem.isQuestion) {
        this.nitem.choices.pop();
      }

      this.loading = true;

      const formData = new FormData();
      const appendIfNotNull = (key, value) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      };

      formData.append("Name", this.nitem.name);
      formData.append("DescriptionAz", this.nitem.descriptionAz);
      formData.append("DescriptionEn", this.nitem.descriptionEn);
      formData.append("LocationAz", this.nitem.locationAz);
      formData.append("LocationEn", this.nitem.locationEn);

      formData.append("IsQuestion", this.nitem.isQuestion);
      formData.append("ScenarioId", this.nitem.scenarioId);
      appendIfNotNull("CharacterId", this.nitem.characterId);
      appendIfNotNull("ParentSceneId", this.nitem.parentSceneId);
      appendIfNotNull("ParentChoiceId", this.nitem.parentChoiceId);

      formData.append("Image", this.nitem.image);

      if (!this.nitem.isQuestion && this.nitem.nextSceneId) {
        if (this.nitem.choices?.length) {
          this.appendIfFilled(formData, "Choices[0].TextAz", "Növbəti");
          this.appendIfFilled(formData, "Choices[0].TextEn", "Next");
          this.appendIfFilled(
            formData,
            "Choices[0].NextSceneId",
            this.nitem.nextSceneId,
          );
          this.appendIfFilled(formData, "Choices[0].ChoiceValueId", null);
          this.appendIfFilled(
            formData,
            "Choices[0].IsCorrect",
            this.nitem.choices?.[0]?.isCorrect ?? true,
          );
        }
      }

      if (this.nitem.isQuestion) {
        this.nitem.choices.forEach((choice, index) => {
          formData.append(`Choices[${index}].TextAz`, choice.textAz);
          formData.append(`Choices[${index}].TextEn`, choice.textEn);
          formData.append(
            `Choices[${index}].ChoiceValueId`,
            choice.choiceValueId,
          );
          formData.append(`Choices[${index}].IsCorrect`, choice.isCorrect);
          formData.append(`Choices[${index}].NextSceneId`, choice.nextSceneId);
        });
      }

      jwtInterceptor
        .post(this.$store.getters.getUrl + "/Scenes", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.$toast.success("Added", { position: "top-right" });
          this.loading = false;
          this.$router.back();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.title, { position: "top-right" });
          this.loading = false;

          if (!this.nitem.choices[1]) {
            this.nitem.choices.push({
              textAz: "",
              textEn: "",
              choiceValueId: null,
            });
          }
        });
    },
    getScenarios() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Scenarios")
        .then((response) => {
          this.scenarios = response.data;

          const mainScenario = this.scenarios.find((x) => x.isMain === true);
          if (mainScenario && !this.nitem.scenarioId) {
            this.nitem.scenarioId = mainScenario.id;
          }
        });
    },
    getCharacters() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Characters")
        .then((response) => {
          this.characters = response.data;
        });
    },
    GetScenesWithChoices() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Scenes/GetScenesWithChoices")
        .then((response) => {
          this.scenesWithChoices = response.data;
        });
    },
    getChoiceValues() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/ChoiceValues")
        .then((response) => {
          this.choiceValues = response.data;
        });
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  computed: {
    filteredChoices() {
      const scene = this.scenesWithChoices.find(
        (x) => x.id === this.nitem.parentSceneId,
      );
      return scene ? scene.choices : [];
    },
  },
  created() {
    this.getCharacters();
    this.getChoiceValues();
    this.getScenarios();
    this.GetScenesWithChoices();
  },
};
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}

.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
